import { Container } from 'components/gruenland/atoms/container/Container';
import Link from 'components/gruenland/atoms/link';
import ReviewsSlider from 'components/gruenland/molecules/product-details/ReviewsSlider';
import { FeedatyProductReviewObject, FeedatyReviewObject } from 'components/gruenland/molecules/product-details/types';
import StarRating from 'components/gruenland/molecules/ratings/StarRating';
import { useFormat } from 'helpers/hooks/useFormat';
import { parseAspNetDate } from 'helpers/utils/dates';
import { TYPOGRAPHY_PDP_REVEW_LABEL, TYPOGRAPHY_PRODUCT_DETAIL_TITLE } from 'lib/typography';
import useAverageRatings from './hooks/useAverageRatings';
import useReviews from './hooks/useReviews';

type Props = {
  productKey?: string;
};

const Reviews: React.FC<Props> = ({ productKey }) => {
  const { reviews } = useReviews(productKey);
  const { rating } = useAverageRatings(productKey);
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <>
      {reviews && (
        <div className="bg-neutrals-gray-light py-20">
          <Container className="flex flex-col items-center gap-5">
            <h2 className={TYPOGRAPHY_PRODUCT_DETAIL_TITLE}>
              {formatMessage({ id: 'feedaty.ratingsAndReviews', defaultMessage: 'Valutazioni e recensioni' })}
            </h2>
            {rating > 0 && (
              <>
                <p className={TYPOGRAPHY_PRODUCT_DETAIL_TITLE}>{rating}</p>
                <StarRating rating={rating} />
              </>
            )}
            <span className={TYPOGRAPHY_PDP_REVEW_LABEL}>
              {formatMessage({
                id: 'feedaty.countReviews',
                defaultMessage: '({count}) recensioni',
                values: { count: reviews.TotalProductReviews },
              })}
            </span>

            <div className="mt-10 h-[300px] w-full">
              <ReviewsSlider
                reviews={reviews.Reviews.flatMap((review: FeedatyReviewObject) =>
                  review.ProductsReviews.map((item: FeedatyProductReviewObject) => ({
                    ...item,
                    Released: parseAspNetDate(review.Released),
                  })),
                )}
              />
            </div>

            <Link link="/tecnologie" className="underline">
              {formatMessage({ id: 'product.technologyLink', defaultMessage: 'Scopri la tecnologia Grünland' })}
            </Link>
          </Container>
        </div>
      )}
    </>
  );
};

export default Reviews;
